import React, {Component} from 'react';
import FilterGenerateList from '../parts/FilterGenerateList';
import Axios from 'axios';
import APIENDPOINT from '../ApiEndpoint';
//

class AantalStudenten extends Component {
    constructor(props){
        super(props);
        this.state = {
            types: [],
            typesfull: [],
            filterOptions: []
        }
    }
    
    async componentDidMount(){
        const {data} = await Axios.get(`${APIENDPOINT}/types`);

        this.setState({typesfull : Object.values(data) });
    }

    findFilterOptions = (needle) => {
        if(this.state.typesfull.length > 0){
            const typeOptions = this.state.typesfull.find(type => type.type_name === needle).options;
             return typeOptions;

        }else{
            return [];
        }
    }
    
    render(){
        return(
            <FilterGenerateList title='Selecteer het aantal studenten' filterOptions={this.findFilterOptions("Aantal studenten")}/>
        )
    }
}

export default AantalStudenten;